import { createSelector } from 'reselect';
import { resolveProp } from '@clearscore-group/lib.helpers.resolve-props';

const marketsSelector = (state) => resolveProp('market.markets', state);

export default createSelector(marketsSelector, (markets) => markets);
